module.exports = __webpack_public_path__ + "img/experience.268f908e.png";